import React, { useState } from 'react';
import { withRouter } from 'react-router';
import List from './list';
import Navigation from './navigation';

const AOListWithTrack = (props) => {
  const [activeLetter, setActiveLetter] = useState(
    props.location.hash
      ? props.location.hash.substring(1)
      : props.list[0]?.Key.toLowerCase()
  );

  const handleLetterChange = (activeLetter) => {
    setActiveLetter(activeLetter);
  };

  if (props.list.length === 0) return null;

  return (
    <div className="ao-list-track-container" data-print-sidebar-title={props.dataPrintSidebarTitle}>
      <div className="ao-list__container">
        <Navigation
          alphabet={props.alphabet}
          activeLetter={activeLetter}
          compare={props.compare}
          handleLetterChange={(activeLetter) =>
            handleLetterChange(activeLetter)
          }
          list={props.list}
        />
      </div>

      <div className="ao-list__drugs">
        {props.list.map((letter, key) => (
          <List
            handleLetterChange={(activeLetter) =>
              handleLetterChange(activeLetter)
            }
            key={key}
            letter={letter.Key}
            list={letter.Items}
          />
        ))}
      </div>
    </div>
  );
};

export default withRouter(AOListWithTrack);
